/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface linksStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export default interface TopBar {
  showTopBarKiosk ? : boolean;
  links ? : Array < linksStruct > ;
  metadata ? : any;
}

export const Props = {
  showTopBarKiosk: Boolean,
  links: Array as() => Array < linksStruct > ,
  metadata: Object,
}

export const WrapperProps = {
  showTopBarKiosk: Boolean,
  links: Object,
  metadata: Object,
}

export class TopBarBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class TopBarInstance implements TopBar {
      showTopBarKiosk ? : boolean;
      links ? : Array < linksStruct > ;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.links) {
          this.links = Object.entries(this.links)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'links' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.links.length; i1++) {

            if (this.links[i1]) {
              if (this.links[i1].switchable) {
                if (typeof this.links[i1].switchable.download === 'object') {
                  this.links[i1].switchable.download = {
                    ...this.links[i1].switchable.download,
                    link: this.links[i1].switchable.download['@link'],
                    name: this.links[i1].switchable.download['@name'],
                    path: this.links[i1].switchable.download['@path'],
                  };
                } else {
                  this.links[i1].switchable.download = null as any;
                }
              }
            }
          }
        } else {
          this.links = null as any;
        }
      }
    }
    return new TopBarInstance(props);
  }
}
